import { render } from "./UiInput.vue?vue&type=template&id=b89f1ff8&scoped=true"
import script from "./UiInput.vue?vue&type=script&lang=js"
export * from "./UiInput.vue?vue&type=script&lang=js"

import "./UiInput.vue?vue&type=style&index=0&id=b89f1ff8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b89f1ff8"]])

export default __exports__